import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CreateOfferRequest, GetOfferRequest, GetOffersRequest, UpdateOfferRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useCreateOffer = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(CreateOfferRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['offers']);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useUpdateOffer = (props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(UpdateOfferRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['offers']);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useGetOffer = (offerId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['offers', `${offerId}`], () => GetOfferRequest(offerId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

const useGetOffers = (props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['offers'], GetOffersRequest, {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

export { useCreateOffer, useUpdateOffer, useGetOffer, useGetOffers };